export default __webpack_public_path__ + "static/media/phase2.b656e36f.png";